import React from "react";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { RenderInput, RenderSelect } from "../../Common/InputComponents/Inputs";
import {
  tooltipFluorophores,
  tooltipSequence,
} from "../../Common/Misc/Tooltips.jsx";
import _ from "underscore";
import {
  requiredTarget,
  requiredSeq,
  // maxLength17,
  minLength5,
  hasValidWhitespace,
  validateCndSequence,
} from "../../../util/validations";
import { removeSpaces, firstSeventeen } from "../../../util/format";
const genomeOptions = [
  "Homo sapiens",
  "Mus musculus",
  "Rattus norvegicus",
  "Other",
];

const fluorophoreOptions = [
  { name: "FAM", value: "FAM" },
  { name: "HEX", value: "HEX" },
  { name: "Cy5", value: "Cy5" },
  { name: "Cy5.5", value: "Cy5_5" },
];

export const CopyNumberDeterminationSequence = ({ input, index, custom }) => {
  const validationErrorDetails =
    (custom &&
      custom.validatedAssayDetails &&
      custom.validatedAssayDetails[index]) ||
    {};
  const copyNumberDeterminationSequence = input && input.name;
  const formObj = custom && custom.formObj;
  const targetByValue =
    formObj &&
    formObj.values &&
    formObj.values.copyNumberDeterminationForm &&
    formObj.values.copyNumberDeterminationForm[index] &&
    formObj.values.copyNumberDeterminationForm[index].targetby;

  const genomeValue =
    formObj &&
    formObj.values &&
    formObj.values.copyNumberDeterminationForm &&
    formObj.values.copyNumberDeterminationForm[index] &&
    formObj.values.copyNumberDeterminationForm[index]
      .copynumberdeterminationsequence &&
    formObj.values.copyNumberDeterminationForm[index]
      .copynumberdeterminationsequence.genome;
  const clearValidationMessages = () => {
    custom.actions.clearValidationMessages(index);
  };
  return (
    <div className="inputs">
      {/* Assay Target Name and remove field button */}
      <div className="row">
        <div className="col-6">
          {/* Assay Target Name */}
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationSequence}.assayTargetName`}
              placeholder="17 chars. maximum"
              className="form-control"
              type="text"
              component={RenderInput}
              label="Assay Target Name:"
              validate={[
                requiredTarget,
                hasValidWhitespace,
                minLength5,
                // maxLength17 # Not Required for the Copy Number Sequence
              ]}
              normalize={firstSeventeen}
            />
          </div>
        </div>
      </div>

      {/* Assay Sequene Text Field */}
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationSequence}.sequence`}
              className="form-control"
              type="textArea"
              rows="8"
              placeholder="e.g., GGTCAGATACAGAGATCACGTAAGGTCCTCGGTAAGTGGAGATCACAGATCGGTAAGTGGAGATCACAGATGGAGATCACAGA (minimum length = 123 base pairs)"
              component={RenderInput}
              label="Sequence:"
              tooltip={tooltipSequence("CopyNumberDetermination")}
              validate={[requiredSeq, validateCndSequence]}
              serverValidation={validationErrorDetails}
              normalize={removeSpaces}
              onChange={clearValidationMessages}
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationSequence}.genome`}
              className="form-control"
              component={RenderSelect}
              label="Genome:"
            >
              {genomeOptions &&
                genomeOptions.map((option) => {
                  return (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  );
                })}
            </Field>
          </div>
          <div className="form-group">
            <Field
              name={`${copyNumberDeterminationSequence}.fluorophores`}
              className="form-control"
              component={RenderSelect}
              label="Fluorophore(s):"
              tooltip={tooltipFluorophores}
            >
              {fluorophoreOptions &&
                fluorophoreOptions.map((option) => {
                  return (
                    <option key={option.name} value={option.value}>
                      {option.name}
                    </option>
                  );
                })}
            </Field>
          </div>
        </div>
      </div>
      <br />
      {/*Warning Text message for others*/}

      {targetByValue === "sequence" && genomeValue === "Other" && (
        <div className="row container d-flex flex-column align-items-start">
          <div className=" warning-header">
            <strong>*Important Note for Selected Genome — Other:</strong>
          </div>

          <div className="warning-descrioption">
            <p>
              The design engine performs a specificity check against the
              reference genome assembly selected. If <b>Other</b> is selected,
              the design engine will not perform a specificity check against a
              reference genome, but all of the other strict assay design
              parameters will be followed. Select your input sequence carefully
              and be as specific as possible.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

CopyNumberDeterminationSequence.propTypes = {
  //fields: PropTypes.object.isRequired,
};
